import { Component, OnInit } from '@angular/core'
import {
  KcDataService
} from '../../../kc-data.service'
import { KcRealmData, KcClientData, KcMessage } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-app-revolution-error',
  templateUrl: './revolution-error.component.html'
})
export class RevolutionErrorComponent implements OnInit {
  constructor (private readonly kcDataService: KcDataService) {}

  public realmData: KcRealmData
  public clientData: KcClientData
  public message: KcMessage

  ngOnInit () {
    this.realmData = this.kcDataService.getRealmData()
    this.clientData = this.kcDataService.getClientData()
    this.message = this.kcDataService.getMessage()
  }
}
